import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import { Formik } from "formik";
import { Form } from "formik";
import { FiEdit } from "react-icons/fi";
import { FcCalendar } from "react-icons/fc";
import Footer from "../../../Components/Footer/footer";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { MdHistory } from "react-icons/md";
import * as Yup from "yup";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
// import { useRef } from "react";
import { toPng } from "html-to-image";
import PodcastCard from "../../Editing Tamplate/templateEditor"; // your template component
import PodcastGuest2Card from "../../Editing Tamplate/podcastGuest2";
import QuoteCard from "../../Editing Tamplate/QuoteTamplate";
import CrouselNewsCard from "../../Editing Tamplate/crouselUImage";

const ViewPostSchedule = () => {
  const { id } = useParams();

  const [schedules, setSchedules] = useState([]);
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const fileInputRef = useRef(null);
  const thumbnailInputRef = useRef(null);
  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  // const templateRef = useRef(null);

  const podcastGuestRef = useRef(null);
  const podcastGuestSecondRef = useRef(null);
  const quoteRef = useRef(null);

  const carouselRef = useRef(null);

  const [currentTemplateSlide, setCurrentTemplateSlide] = useState({
    carousel: null,
    podcastGuestSecond: null,
  });

  const templateRefs = {
    podcastGuest: podcastGuestRef,
    podcastGuestSecond: podcastGuestSecondRef,
    quote: quoteRef,
    carousel: carouselRef,

    // template4: template4Ref,
  };

  const templatePlanMap = {
    "PLAN-1784116305499": "podcastGuest",
    "PLAN-1783935974809": "quote",
    "PLAN-1783936989539": "carousel",
    "PLAN-1784116206988": "podcastGuestSecond",
    "PLAN-1784116397839": "quote",
  };

  const [filters, setFilters] = useState({
    date: "",
    day: "",
  });

  const getSchedules = (filterData = filters) => {
    setLoading(true);

    let params = [];

    if (filterData.date) {
      params.push(`date=${filterData.date}`);
    }

    if (filterData.day) {
      params.push(`day=${filterData.day}`);
    }

    const query = params.length ? `?${params.join("&")}` : "";

    performRequest("GET", `/postPlanning/view-post-schedule/${id}${query}`)
      .then((res) => {
        if (res.status === 200) {
          setSchedules(res.data.data);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getSchedules();
  }, [id]);

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  const generatePngFromElement = async (element) => {
    if (!element) {
      throw new Error("Template element not found");
    }

    // Save original styles
    const originalStyles = {
      width: element.style.width,
      height: element.style.height,
      minWidth: element.style.minWidth,
      minHeight: element.style.minHeight,
      maxWidth: element.style.maxWidth,
      maxHeight: element.style.maxHeight,
      transform: element.style.transform,
      transformOrigin: element.style.transformOrigin,
    };

    try {
      // IMPORTANT:
      // Lock template to fixed 1080 x 1350 during image generation
      element.style.width = "1080px";
      element.style.height = "1350px";
      element.style.minWidth = "1080px";
      element.style.minHeight = "1350px";
      element.style.maxWidth = "1080px";
      element.style.maxHeight = "1350px";
      element.style.transform = "none";
      element.style.transformOrigin = "top left";

      // Force browser to calculate layout again
      void element.offsetWidth;

      // Wait for render
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));

      await new Promise((resolve) => requestAnimationFrame(() => resolve()));

      // Generate fixed-size PNG
      const dataUrl = await toPng(element, {
        cacheBust: true,

        width: 1080,
        height: 1350,

        canvasWidth: 1080,
        canvasHeight: 1350,

        pixelRatio: 1,

        style: {
          width: "1080px",
          height: "1350px",
          minWidth: "1080px",
          minHeight: "1350px",
          maxWidth: "1080px",
          maxHeight: "1350px",
          transform: "none",
          transformOrigin: "top left",
        },
      });

      return dataUrl;
    } finally {
      // Restore original styles
      element.style.width = originalStyles.width;
      element.style.height = originalStyles.height;
      element.style.minWidth = originalStyles.minWidth;
      element.style.minHeight = originalStyles.minHeight;
      element.style.maxWidth = originalStyles.maxWidth;
      element.style.maxHeight = originalStyles.maxHeight;
      element.style.transform = originalStyles.transform;
      element.style.transformOrigin = originalStyles.transformOrigin;
    }
  };

  const generateTemplateImage = async (values) => {
    try {
      console.log("Generating template...");

      // Wait React render
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));

      await new Promise((resolve) => requestAnimationFrame(() => resolve()));

      const element = templateRefs[values.templateName]?.current;

      if (!element) {
        console.error("Template not found");
        return null;
      }

      console.log("Element:", element);

      // Wait for state update
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const images = Array.from(element.querySelectorAll("img"));

      console.log("Images found:", images.length);

      await Promise.all(
        images.map(async (img, index) => {
          console.log("Image before load", index, {
            srcAttribute: img.getAttribute("src"),
            src: img.src,
            complete: img.complete,
            naturalWidth: img.naturalWidth,
          });

          // invalid image
          if (!img.getAttribute("src")) {
            console.log("Empty image", index);
            return;
          }

          if (img.complete && img.naturalWidth > 0) {
            if (img.decode) {
              try {
                await img.decode();
              } catch (e) {}
            }

            return;
          }

          await new Promise((resolve) => {
            img.onload = async () => {
              console.log("Loaded image", index);

              if (img.decode) {
                try {
                  await img.decode();
                } catch (e) {}
              }

              resolve();
            };

            img.onerror = () => {
              console.log("Image error", index, img.src);

              resolve();
            };
          });
        })
      );

      // final render wait
      await new Promise((resolve) => setTimeout(resolve, 500));

      console.log("Before PNG");

      images.forEach((img, index) => {
        console.log("Final image", index, {
          src: img.src,
          width: img.naturalWidth,
        });
      });

      // const dataUrl = await toPng(element, {
      //   cacheBust: true,
      //   pixelRatio: 1,
      //   width: 1080,
      //   height: 1350,
      //   canvasWidth: 1080,
      //   canvasHeight: 1350,
      // });

      const dataUrl = await generatePngFromElement(element);

      console.log("PNG Generated");

      const blob = await fetch(dataUrl).then((res) => res.blob());

      const file = new File(
        [blob],
        `${values.templateName}-${Date.now()}.png`,
        {
          type: "image/png",
        }
      );

      const signedRes = await performRequest(
        "POST",
        "/postPlanning/generateUploadUrl",
        {
          fileName: file.name,
          contentType: file.type,
        }
      );

      await axios.put(signedRes.data.uploadUrl, file, {
        headers: {
          "Content-Type": file.type,
        },
      });

      console.log("Uploaded", signedRes.data.publicUrl);

      return signedRes.data.publicUrl;
    } catch (error) {
      console.error("generateTemplateImage error", error);

      return null;
    }
  };

  const generateTemplateCarouselImage = async (values) => {
    try {
      let slides = [];
      let activeRef = null;
      let templateKey = values.templateName;

      setSubmitting(true);
      // ============================
      // SELECT CAROUSEL TYPE
      // ============================

      if (templateKey === "carousel") {
        slides = values.templateData.slides;
        activeRef = carouselRef;
      } else if (templateKey === "podcastGuestSecond") {
        slides = values.templateData.guestCarouselSlides;
        activeRef = podcastGuestSecondRef;
      } else {
        return await generateTemplateImage(values);
      }

      const uploadedUrls = [];

      // ============================
      // LOOP SLIDES
      // ============================

      for (let i = 0; i < slides.length; i++) {
        const slide = slides[i];

        if (!slide) {
          continue;
        }

        console.log("Generating", templateKey, "Slide", i + 1);

        // ============================
        // SET CURRENT SLIDE
        // ============================

        setCurrentTemplateSlide({
          carousel: templateKey === "carousel" ? slide : null,

          podcastGuestSecond:
            templateKey === "podcastGuestSecond" ? slide : null,
        });

        // wait react render

        await new Promise((r) => requestAnimationFrame(r));
        await new Promise((r) => requestAnimationFrame(r));
        await new Promise((r) => setTimeout(r, 1500));

        const element = activeRef.current;

        if (!element) {
          console.log("Ref not found", templateKey);
          continue;
        }

        // ============================
        // WAIT IMAGES
        // ============================

        const images = [...element.querySelectorAll("img")];

        await Promise.all(
          images.map((img) => {
            if (img.complete && img.naturalWidth > 0) {
              return Promise.resolve();
            }

            return new Promise((resolve) => {
              img.onload = resolve;
              img.onerror = resolve;
            });
          })
        );

        await new Promise((r) => setTimeout(r, 300));

        // ============================
        // PNG
        // ============================

        // const dataUrl = await toPng(element, {
        //   cacheBust: true,
        //   pixelRatio: 1,
        //   width: 1080,
        //   height: 1350,
        //   canvasWidth: 1080,
        //   canvasHeight: 1350,
        // });

        const dataUrl = await generatePngFromElement(element);

        const blob = await fetch(dataUrl).then((r) => r.blob());

        const file = new File(
          [blob],
          `${templateKey}-${i + 1}-${Date.now()}.png`,
          {
            type: "image/png",
          }
        );

        const signedRes = await performRequest(
          "POST",
          "/postPlanning/generateUploadUrl",
          {
            fileName: file.name,
            contentType: file.type,
          }
        );

        await axios.put(signedRes.data.uploadUrl, file, {
          headers: {
            "Content-Type": file.type,
          },
        });

        uploadedUrls.push(encodeURI(signedRes.data.publicUrl));

        console.log("Uploaded slide", i + 1);
      }

      return uploadedUrls;
    } catch (err) {
      console.error("Carousel Error", err);

      return [];
    } finally {
      // Loading will stop on success, error, or return
      setSubmitting(false);
    }
  };


  const capitalizeFirstLetter = (value = "") => {
    return value
      .trim()
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handelSubmit = async (values) => {
    try {
      let uploadedUrls = [];

      let templateImageUrl = null;

      if (values.templateName && values?.type === "Template Upload") {
        console.log("Generating template...");
        templateImageUrl = await generateTemplateCarouselImage(values);
        console.log("Generated:", templateImageUrl);
      }

      console.log("Continue submit...");

      console.log("tamplte url", templateImageUrl);

      setSubmitting(true);

      // Thumbnail
      let thumbnailUrl =
        typeof values.thumbnail === "string"
          ? values.thumbnail
          : values.thumbnail;

      // Upload thumbnail if it's a new file
      if (values.thumbnail && typeof values.thumbnail !== "string") {
        const signedRes = await performRequest(
          "POST",
          "/postPlanning/generateUploadUrl",
          {
            fileName: values.thumbnail.name,
            contentType: values.thumbnail.type,
          }
        );

        await axios.put(signedRes.data.uploadUrl, values.thumbnail, {
          headers: {
            "Content-Type": values.thumbnail.type,
          },
        });

        // Save encoded public URL
        thumbnailUrl = encodeURI(signedRes.data.publicUrl);
      }

      if (values.images && values.images.length > 0) {
        for (const file of values.images) {
          // If it's already a URL, encode it and keep it
          if (typeof file === "string") {
            uploadedUrls.push(file); // Keep the existing URL unchanged
            continue;
          }

          // 1. Get signed URL
          const signedRes = await performRequest(
            "POST",
            "/postPlanning/generateUploadUrl",
            {
              fileName: file.name,
              contentType: file.type,
            }
          );

          // 2. Upload directly to GCS
          await axios.put(signedRes.data.uploadUrl, file, {
            headers: {
              "Content-Type": file.type,
            },
          });

          // 3. Save encoded public URL
          uploadedUrls.push(encodeURI(signedRes.data.publicUrl));
        }
      }

      // ================================
      // FINAL IMAGE ARRAY
      // ================================

      let finalImages = [];

      if (
        values.templateName === "carousel" &&
        values.type === "Template Upload"
      ) {
        // Add fixed first and last image only for carousel
        finalImages = [
          "https://res.cloudinary.com/bsgfcooa/image/upload/v1785394742/fist_slide_kxyk8a.png",

          ...(Array.isArray(templateImageUrl) ? templateImageUrl : []),

          "https://res.cloudinary.com/bsgfcooa/image/upload/v1785394742/last_slide_vv1xpx.png",
        ];
      } else if (
        Array.isArray(templateImageUrl) &&
        values.type === "Template Upload"
      ) {
        finalImages = templateImageUrl;
      } else if (templateImageUrl && values.type === "Template Upload") {
        finalImages = [templateImageUrl];
      } else {
        finalImages = uploadedUrls;
      }

      let videoId = values?.videoId;
      let guestName = `${capitalizeFirstLetter(values.templateData?.firstName || "")} ${capitalizeFirstLetter(values.templateData?.lastName || "")}`.trim() || values?.guest || "";

      // Update schedule
      const response = await performRequest(
        "PATCH",
        "/postPlanning/update-post-schedule",
        {
          id: values.id,
          script: values.script,
          platforms: values.platforms,

          images: finalImages,

          thumbnail: thumbnailUrl,
          deletedImages: values.deletedImages || [],
          deletedThumbnail: values.deletedThumbnail,
          updatedBy: store?.Name || "",
          videoId: videoId || "",
          guest: guestName ,
          podcastTopicName: values?.podcastTopicName || "",
        }
      );

      // // 4. Update schedule
      // const response = await performRequest(
      //   "PATCH",
      //   "/postPlanning/update-post-schedule",
      //   {
      //     id: values.id,
      //     script: values.script,
      //     platforms: values.platforms,
      //     images: Array.isArray(templateImageUrl)
      //       ? templateImageUrl
      //       : templateImageUrl
      //       ? [templateImageUrl]
      //       : uploadedUrls,

      //     thumbnail: thumbnailUrl,
      //     deletedImages: values.deletedImages || [],
      //     deletedThumbnail: values.deletedThumbnail,
      //     updatedBy: store?.Name || "",
      //   }
      // );

      if (response.status === 200) {
        Toast("success", "Schedule updated successfully");
        // close modal
        const closeBtn = document.getElementById(`modal-close-${values.id}`);

        if (closeBtn) {
          closeBtn.click();
        }
        // refresh list
        getSchedules();
      }
    } catch (error) {
      CustomErrorResponse(error);
    } finally {
      setSubmitting(false);
    }
  };

  const getFileSrc = (file) => {
    if (file instanceof File) {
      return URL.createObjectURL(file);
    }

    if (typeof file === "string") {
      return file;
    }

    return file?.url || "";
  };

  const isVideo = (file) => {
    if (file instanceof File) {
      return file.type.startsWith("video/");
    }

    const src = typeof file === "string" ? file : file?.url || "";

    return /\.(mp4|mov|avi|webm|mkv)$/i.test(src);
  };

  const getHistory = async (id) => {
    try {
      setHistoryLoading(true);

      const response = await performRequest(
        "GET",
        `/postPlanning/history/${id}`
      );

      if (response.status === 200) {
        setHistory(response.data.data);
      }
    } catch (err) {
      CustomErrorResponse(err);
    } finally {
      setHistoryLoading(false);
    }
  };

  const validationSchema = Yup.object({
    script: Yup.string().trim().required("Script is required"),
    type: Yup.string().trim().required("Type is required"),
  });

  return (
    <div className="container-fluid mt-4">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white d-flex justify-content-between align-items-center">
          <div>
            <h2 className="mb-1">
              <FcCalendar></FcCalendar> Schedule Details
            </h2>
            <h5 className="text-muted">
              View and manage post publishing schedules
            </h5>
          </div>
          <hr></hr>

          <div className="d-flex gap-2 align-items-center">
            <input
              type="date"
              className="form-control"
              name="date"
              value={filters.date}
              onChange={handleFilterChange}
            />

            <select
              className="form-select"
              name="day"
              value={filters.day}
              onChange={handleFilterChange}
            >
              <option value="">Select Day</option>
              <option value="Sunday">Sunday</option>
              <option value="Monday">Monday</option>
              <option value="Tuesday">Tuesday</option>
              <option value="Wednesday">Wednesday</option>
              <option value="Thursday">Thursday</option>
              <option value="Friday">Friday</option>
              <option value="Saturday">Saturday</option>
            </select>

            <button
              className="btn btn-primary px-4"
              onClick={() => getSchedules(filters)}
            >
              Filter
            </button>

            <button
              className="btn btn-outline-secondary px-4"
              onClick={() => {
                const resetFilters = {
                  date: "",
                  day: "",
                };

                setFilters(resetFilters);
                getSchedules(resetFilters);
              }}
            >
              Clear
            </button>
          </div>
        </div>

        <div className="card-body p-0 ">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <p className="mt-2 text-muted">Loading schedules...</p>
            </div>
          ) : (
            <div style={{ overflow: "scroll", height: "730px" }}>
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="ps-4">Sr.</th>
                      <th>Date</th>
                      <th>Day</th>
                      <th>Page</th>
                      <th>Format/Time</th>
                      <th>Thumbnail</th>
                      <th>Media</th>

                      {/* <th>Status</th> */}
                      <th className="text-center">Action</th>
                      <th className="text-center">View History</th>
                    </tr>
                  </thead>

                  <tbody>
                    {schedules.length > 0 ? (
                      schedules.map((item, index) => (
                        <>
                          <tr key={item.id}>
                            <td className="ps-4 fw-semibold">{index + 1}</td>

                            <td>
                              <span className="badge bg-light text-dark">
                                {item.date}
                              </span>
                            </td>

                            <td>
                              <span className="badge bg-info-subtle text-info">
                                {item.day}
                              </span>
                            </td>

                            <td>
                              <strong>{item.pageName}</strong>
                            </td>

                            <td>
                              {item.format}
                              <div className="border"></div>
                              {new Date(
                                `1970-01-01T${item.time}`
                              ).toLocaleTimeString("en-US", {
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </td>

                            <td>
                              {/* {item.thumbnail} */}
                              <div key={index}>
                                <a
                                  href={item.thumbnail}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title={item.thumbnail}
                                >
                                  {item.thumbnail.length > 50
                                    ? `${item.thumbnail.slice(0, 50)}...`
                                    : item.thumbnail}
                                </a>
                              </div>
                            </td>

                            {/* <td>
                            {item.filepath ? (
                              <a
                                href={item.filepath}
                                target="_blank"
                                rel="noopener noreferrer"
                                title={item.filepath}
                              >
                                {item.filepath.length > 50
                                  ? `${item.filepath.slice(0, 50)}...`
                                  : item.filepath}
                              </a>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td> */}

                            <td>
                              {item.images && item.images.length > 0 ? (
                                item.images.map((image, index) => (
                                  <div key={index}>
                                    <a
                                      href={image}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      title={image}
                                    >
                                      {image.length > 50
                                        ? `${image.slice(0, 50)}...`
                                        : image}
                                    </a>
                                  </div>
                                ))
                              ) : (
                                <span className="text-muted">-</span>
                              )}
                            </td>

                            <td className="text-center">
                              <button
                                className="btn btn-sm btn-primary rounded-circle"
                                data-bs-toggle="modal"
                                data-bs-target={`#modal-schedule-${item?.id}`}
                                title="Edit Schedule"
                              >
                                <FiEdit size={18} />
                              </button>
                            </td>
                            <td className="text-center">
                              <button
                                className="btn btn-sm btn-primary rounded-circle"
                                data-bs-toggle="modal"
                                data-bs-target={`#history-modal-${item.id}`}
                                onClick={() => getHistory(item.id)}
                              >
                                <MdHistory size={20} />
                              </button>
                            </td>
                          </tr>
                          <div
                            className="modal modal-blur fade"
                            id={`modal-schedule-${item?.id}`}
                            tabIndex="-1"
                            role="dialog"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered modal-lg">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    Update Schedule
                                  </h5>

                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    id={`modal-close-${item.id}`}
                                  ></button>
                                </div>

                                <Formik
                                  initialValues={{
                                    id: item?.id,
                                    pageName: item?.pageName || "",
                                    format: item?.format || "",
                                    date: item?.date || "",
                                    day: item?.day || "",
                                    time: item?.time || "",
                                    topic: item?.topic || "",
                                    description: item?.description || "",
                                    fileFormat: item?.fileFormat || "",
                                    filepath: item?.filepath || "",
                                    script: item?.script || "",
                                    images:
                                      typeof item.images === "string"
                                        ? JSON.parse(item.images)
                                        : item.images || [],
                                    platforms: item?.platforms || [],
                                    thumbnail: item?.thumbnail || "",
                                    deletedImages: [],
                                    deletedThumbnail: "",
                                    templateData: {
                                      // Podcast Guest
                                      guestImage: "",
                                      guestImageFile: "",
                                      firstName: "",
                                      lastName: "",

                                      // Podcast Guest Second
                                      image: "",
                                      imageFile: "",
                                      guestDescription: "",
                                      guestFullName: "",

                                      // Quote
                                      quote: "",

                                      // Daily News
                                      slides: [
                                        {
                                          image: "",
                                          imageFile: "",
                                          description: "",
                                        },
                                      ],

                                      // Podcast Guest Carousel
                                      guestCarouselSlides: [
                                        {
                                          image: "",
                                          imageFile: "",
                                          guestDescription: "",
                                          guestFullName: "",
                                        },
                                      ],
                                    },
                                    // templateData:
                                    //   typeof item.templateData === "string"
                                    //     ? JSON.parse(item.templateData)
                                    //     : item.templateData || {},
                                    guestImageFile: null,
                                    // templateName: "",
                                    templateName:
                                      templatePlanMap[item?.scheduleGroupId] ||
                                      "",
                                    type: "Manual Upload",
                                    guest: item?.guest || "",
                                    videoId: item?.videoId || "",
                                    podcastTopicName: item?.podcastTopicName || "",
                                  }}
                                  validationSchema={validationSchema}
                                  onSubmit={handelSubmit}
                                >
                                  {(props) => {
                                    const onDragEnd = (result) => {
                                      if (!result.destination) return;

                                      const items = [...props.values.images];

                                      const [reorderedItem] = items.splice(
                                        result.source.index,
                                        1
                                      );

                                      items.splice(
                                        result.destination.index,
                                        0,
                                        reorderedItem
                                      );

                                      props.setFieldValue("images", items);
                                    };

                                    return (
                                      <Form>
                                        <div
                                          // style={{
                                          //   position: "fixed",
                                          //   left: "-9999px",
                                          //   top: 0,
                                          //   visibility: "visible",
                                          //   zIndex: -1,
                                          // }}

                                          style={{
                                            position: "fixed",
                                            left: "-9999px",
                                            top: 0,
                                            width: "1080px",
                                            height: "1350px",
                                            overflow: "hidden",
                                            visibility: "visible",
                                            zIndex: -1,
                                          }}
                                        >
                                          {props.values.templateData
                                            ?.guestImage &&
                                            props.values.templateData
                                              ?.firstName &&
                                            props.values.templateData
                                              .lastName && (
                                              <div ref={podcastGuestRef}>
                                                <PodcastCard
                                                  guestImage={
                                                    props.values.templateData
                                                      .guestImage
                                                  }
                                                  firstName={
                                                    props.values.templateData
                                                      .firstName
                                                  }
                                                  lastName={
                                                    props.values.templateData
                                                      .lastName
                                                  }
                                                />
                                              </div>
                                            )}

                                          {/* {props.values.templateData.image &&
                                            props.values.templateData
                                              .guestDescription &&
                                            props.values.templateData
                                              .guestFullName && (
                                              <div ref={podcastGuestSecondRef}>
                                                <PodcastGuest2Card
                                                  image={
                                                    props.values.templateData
                                                      .image
                                                  }
                                                  guestDescription={
                                                    props.values.templateData
                                                      .guestDescription
                                                  }
                                                  guestFullName={
                                                    props.values.templateData
                                                      .guestFullName
                                                  }
                                                />
                                              </div>
                                            )} */}

                                          {props.values.templateData.quote && (
                                            <div ref={quoteRef}>
                                              <QuoteCard
                                                quote={
                                                  props.values.templateData
                                                    .quote
                                                }
                                              />
                                            </div>
                                          )}
                                          {currentTemplateSlide.carousel
                                            ?.image &&
                                            currentTemplateSlide.carousel
                                              ?.description && (
                                              <div ref={carouselRef}>
                                                <CrouselNewsCard
                                                  image={
                                                    currentTemplateSlide
                                                      .carousel.image
                                                  }
                                                  description={
                                                    currentTemplateSlide
                                                      .carousel.description
                                                  }
                                                />
                                              </div>
                                            )}

                                          {props.values.templateName ===
                                            "podcastGuestSecond" && (
                                            <div ref={podcastGuestSecondRef}>
                                              <PodcastGuest2Card
                                                image={
                                                  currentTemplateSlide
                                                    .podcastGuestSecond
                                                    ?.image || ""
                                                }
                                                guestDescription={
                                                  currentTemplateSlide
                                                    .podcastGuestSecond
                                                    ?.guestDescription || ""
                                                }
                                                guestFullName={
                                                  currentTemplateSlide
                                                    .podcastGuestSecond
                                                    ?.guestFullName || ""
                                                }
                                              />
                                            </div>
                                          )}
                                          {/* 
                                          <div ref={template4Ref}>
                                            <Template4
                                              title={
                                                props.values.templateData.title
                                              }
                                            />
                                          </div> */}
                                        </div>
                                        <div className="modal-body">
                                          {/* Page Name */}
                                          <div className="row mb-3">
                                            <label className="form-label col-3">
                                              Page
                                            </label>

                                            <div className="col-9">
                                              <CustomInput
                                                name="pageName"
                                                type="text"
                                                disabled
                                              />
                                            </div>
                                          </div>

                                          <div className="row mb-3">
                                            <label className="form-label col-3 required">
                                              Type
                                            </label>

                                            <div className="col-9">
                                              <select
                                                className="form-select"
                                                value={props.values.type}
                                                onChange={(e) => {
                                                  props.setFieldValue(
                                                    "type",
                                                    e.target.value
                                                  );
                                                }}
                                              >
                                                <option value="">Select</option>
                                                <option value="Manual Upload">
                                                  Manual Upload
                                                </option>
                                                <option value="Template Upload">
                                                  Template Upload
                                                </option>
                                              </select>
                                              {props.touched.type &&
                                                props.errors.type && (
                                                  <p className="text-danger">
                                                    {" "}
                                                    {props.errors.type}{" "}
                                                  </p>
                                                )}
                                            </div>
                                          </div>

                                          {props.values.type ===
                                            "Template Upload" && (
                                            <div className="row mb-3">
                                              <label className="form-label col-3">
                                                Template
                                              </label>

                                              <div className="col-9">
                                                <select
                                                  className="form-select"
                                                  disabled
                                                  value={
                                                    props.values.templateName
                                                  }
                                                  onChange={(e) => {
                                                    props.setFieldValue(
                                                      "templateName",
                                                      e.target.value
                                                    );
                                                  }}
                                                >
                                                  <option value="">
                                                    Select Template
                                                  </option>
                                                  <option value="podcastGuest">
                                                    We Are Live On
                                                    YouTube(PLAN-1784116305499)
                                                  </option>
                                                  <option value="podcastGuestSecond">
                                                    3 Guest-quote Carousels +
                                                    Final Promo Image (previous
                                                    Podcast)(PLAN-1784116206988)
                                                  </option>
                                                  <option value="quote">
                                                    Quote(HM) && Quote(OTWSD)
                                                  </option>
                                                  <option value="carousel">
                                                    This Week In Horticultural
                                                    (top 5 News Of The
                                                    Week)(PLAN-1783936989539)
                                                  </option>
                                                </select>
                                              </div>
                                            </div>
                                          )}

                                          {/* Format */}
                                          {/* <div className="row mb-3">
                                    <label className="form-label col-3">
                                      Format
                                    </label>

                                    <div className="col-9">
                                      <CustomInput
                                        name="format"
                                        type="text"
                                        disabled
                                      />
                                    </div>
                                  </div> */}

                                          {/* Date */}
                                          <div className="row mb-3">
                                            <label className="form-label col-3">
                                              Date
                                            </label>

                                            <div className="col-9">
                                              <CustomInput
                                                name="date"
                                                type="date"
                                                disabled
                                              />
                                            </div>
                                          </div>

                                          {/* Day */}
                                          <div className="row mb-3">
                                            <label className="form-label col-3">
                                              Day
                                            </label>

                                            <div className="col-9">
                                              <CustomInput
                                                name="day"
                                                type="text"
                                                disabled
                                              />
                                            </div>
                                          </div>

                                          {/* Media */}
                                          <div className="row mb-3">
                                            <label className="form-label col-3">
                                              Media
                                            </label>

                                            <div className="col-9">
                                              <CustomInput
                                                ref={fileInputRef}
                                                name="images"
                                                type="file"
                                                accept="image/*,video/*"
                                                multiple
                                                onChange={(e) => {
                                                  const files = Array.from(
                                                    e.target.files
                                                  );
                                                  // props.setFieldValue(
                                                  //   "images",
                                                  //   files
                                                  // );

                                                  props.setFieldValue(
                                                    "images",
                                                    [
                                                      ...(props.values.images ||
                                                        []),
                                                      ...files,
                                                    ]
                                                  );
                                                  if (fileInputRef.current) {
                                                    fileInputRef.current.value =
                                                      "";
                                                  }
                                                }}
                                              />

                                              <DragDropContext
                                                onDragEnd={onDragEnd}
                                              >
                                                <Droppable
                                                  droppableId="images"
                                                  direction="horizontal"
                                                >
                                                  {(provided) => (
                                                    <div
                                                      className="d-flex flex-wrap gap-3 mt-3 border"
                                                      ref={provided.innerRef}
                                                      {...provided.droppableProps}
                                                    >
                                                      {props?.values.images?.map(
                                                        (file, index) => {
                                                          const src =
                                                            getFileSrc(file);

                                                          return (
                                                            <Draggable
                                                              key={index.toString()}
                                                              draggableId={index.toString()}
                                                              index={index}
                                                            >
                                                              {(provided) => (
                                                                <div
                                                                  ref={
                                                                    provided.innerRef
                                                                  }
                                                                  {...provided.draggableProps}
                                                                  {...provided.dragHandleProps}
                                                                  className="border p-2 text-center"
                                                                >
                                                                  {isVideo(
                                                                    file
                                                                  ) ? (
                                                                    <video
                                                                      src={src}
                                                                      controls
                                                                      style={{
                                                                        width: 100,
                                                                        height: 100,
                                                                        objectFit:
                                                                          "cover",
                                                                      }}
                                                                    />
                                                                  ) : (
                                                                    <img
                                                                      src={src}
                                                                      alt="preview"
                                                                      style={{
                                                                        width: 100,
                                                                        height: 100,
                                                                        objectFit:
                                                                          "cover",
                                                                      }}
                                                                    />
                                                                  )}

                                                                  <br />

                                                                  <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm mt-2"
                                                                    onClick={() => {
                                                                      const removedFile =
                                                                        props
                                                                          ?.values
                                                                          .images[
                                                                          index
                                                                        ];

                                                                      if (
                                                                        typeof removedFile ===
                                                                        "string"
                                                                      ) {
                                                                        props.setFieldValue(
                                                                          "deletedImages",
                                                                          [
                                                                            ...(props
                                                                              ?.values
                                                                              .deletedImages ||
                                                                              []),
                                                                            removedFile,
                                                                          ]
                                                                        );
                                                                      }

                                                                      props.setFieldValue(
                                                                        "images",
                                                                        props.values.images.filter(
                                                                          (
                                                                            _,
                                                                            i
                                                                          ) =>
                                                                            i !==
                                                                            index
                                                                        )
                                                                      );

                                                                      if (
                                                                        fileInputRef.current
                                                                      ) {
                                                                        fileInputRef.current.value =
                                                                          "";
                                                                      }
                                                                    }}
                                                                  >
                                                                    Remove
                                                                  </button>
                                                                </div>
                                                              )}
                                                            </Draggable>
                                                          );
                                                        }
                                                      )}

                                                      {provided.placeholder}
                                                    </div>
                                                  )}
                                                </Droppable>
                                              </DragDropContext>
                                            </div>
                                          </div>

                                          {/* script */}

                                          <div className="row mb-3">
                                            <label className="form-label col-3 required">
                                              Script
                                            </label>

                                            <div className="col-9">
                                              <CustomTextArea
                                                name="script"
                                                type="text"
                                              />
                                              {props.touched.script &&
                                                props.errors.script && (
                                                  <p className="text-danger">
                                                    {" "}
                                                    {props.errors.script}{" "}
                                                  </p>
                                                )}
                                            </div>
                                          </div>

                                          {/* <div className="mb-3 row">
                                            <label className="w-25 form-label col-3">
                                              Platforms
                                            </label>

                                            <div className="w-100 col">
                                              {[
                                                "instagram",
                                                "facebook",
                                                "youtube",
                                                "linkdin",
                                                "X.com",
                                                "Threads",
                                              ].map((platform) => (
                                                <div
                                                  className="form-check"
                                                  key={platform}
                                                >
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={platform}
                                                    checked={props.values.platforms.includes(
                                                      platform
                                                    )}
                                                    onChange={(e) => {
                                                      if (e.target.checked) {
                                                        props.setFieldValue(
                                                          "platforms",
                                                          [
                                                            ...props.values
                                                              .platforms,
                                                            platform,
                                                          ]
                                                        );
                                                      } else {
                                                        props.setFieldValue(
                                                          "platforms",
                                                          props.values.platforms.filter(
                                                            (p) =>
                                                              p !== platform
                                                          )
                                                        );
                                                      }
                                                    }}
                                                  />
                                                  <label
                                                    className="form-check-label"
                                                    htmlFor={platform}
                                                  >
                                                    {platform
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                      platform.slice(1)}
                                                  </label>
                                                </div>
                                              ))}
                                            </div>
                                          </div> */}
                                          {/* <div className="mb-3 row">
                                            <label className="w-25 form-label col-3">
                                              Platforms
                                            </label>

                                            <div className="w-100 col">
                                              <div className="d-flex flex-wrap gap-2">
                                                {[
                                                  "instagram",
                                                  "facebook",
                                                  "youtube",
                                                  "linkdin",
                                                  "X.com",
                                                  "Threads",
                                                ].map((platform) => (
                                                  <div
                                                    className="form-check"
                                                    key={platform}
                                                  >
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={platform}
                                                      checked={props.values.platforms.includes(
                                                        platform
                                                      )}
                                                      onChange={(e) => {
                                                        if (e.target.checked) {
                                                          props.setFieldValue(
                                                            "platforms",
                                                            [
                                                              ...props.values
                                                                .platforms,
                                                              platform,
                                                            ]
                                                          );
                                                        } else {
                                                          props.setFieldValue(
                                                            "platforms",
                                                            props.values.platforms.filter(
                                                              (p) =>
                                                                p !== platform
                                                            )
                                                          );
                                                        }
                                                      }}
                                                    />

                                                    <label
                                                      className="form-check-label"
                                                      htmlFor={platform}
                                                    >
                                                      {platform
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                        platform.slice(1)}
                                                    </label>
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          </div> */}
                                          <hr className="mb-0"></hr>
                                          {props.values.type ===
                                            "Template Upload" && (
                                            <div>
                                              {props.values.templateName ===
                                                "podcastGuest" && (
                                                <>
                                                
                                                  <h3 className="p-0 mt-1">
                                                    Upload Templatte Data
                                                  </h3>
                                                  <hr className="m-0 p-0"></hr>
                                                  <div className="row mb-3 mt-2">
                                                    <label className="form-label col-3">
                                                      Guest Image
                                                    </label>

                                                    <div className="col-9">
                                                      <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                          const file =
                                                            e.target.files[0];

                                                          if (!file) return;

                                                          // Store original file
                                                          props.setFieldValue(
                                                            "guestImageFile",
                                                            file
                                                          );

                                                          // Convert to Base64
                                                          const reader =
                                                            new FileReader();

                                                          reader.onload =
                                                            () => {
                                                              props.setFieldValue(
                                                                "templateData.guestImage",
                                                                reader.result
                                                              );
                                                            };

                                                          reader.readAsDataURL(
                                                            file
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="row mb-3">
                                                    <label className="form-label col-3">
                                                      First Name
                                                    </label>

                                                    <div className="col-9">
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        value={
                                                          props.values
                                                            .templateData
                                                            .firstName
                                                        }
                                                        onChange={(e) =>
                                                          props.setFieldValue(
                                                            "templateData.firstName",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="row mb-3">
                                                    <label className="form-label col-3">
                                                      Last Name
                                                    </label>
                                                    <div className="col-9">
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        value={
                                                          props.values
                                                            .templateData
                                                            .lastName
                                                        }
                                                        onChange={(e) =>
                                                          props.setFieldValue(
                                                            "templateData.lastName",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                  <hr className="m-1 p-0"></hr>
                                                  <h3>
                                                    After Upload Podcast On
                                                    Youtube
                                                  </h3>
                                                  <hr className="m-1 p-0"></hr>
                                                  <div className="row mb-3 mt-2">
                                                    <label className="form-label col-3">
                                                      Podcast Link
                                                    </label>

                                                    <div className="col-9">
                                                      <CustomInput
                                                        name="videoId"
                                                        type="text"
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="row mb-3">
                                                    <label className="form-label col-3">
                                                      Podcast Topic Name
                                                    </label>

                                                    <div className="col-9">
                                                      <CustomInput
                                                        name="podcastTopicName"
                                                        type="text"
                                                      />
                                                    </div>
                                                  </div>
                                                </>
                                              )}

                                              {/* {props.values.templateName ===
                                            "podcastGuestSecond" && (
                                            <>
                                              <div className="row mb-3">
                                                <label className="form-label col-3">
                                                  Guest Image
                                                </label>

                                                <div className="col-9">
                                                  <input
                                                    type="file"
                                                    accept="image/*"
                                                    className="form-control"
                                                    onChange={(e) => {
                                                      const file =
                                                        e.target.files[0];

                                                      if (!file) return;

                                                      // Store original file
                                                      props.setFieldValue(
                                                        "imageFile",
                                                        file
                                                      );

                                                      // Convert to Base64
                                                      const reader =
                                                        new FileReader();

                                                      reader.onload = () => {
                                                        props.setFieldValue(
                                                          "templateData.image",
                                                          reader.result
                                                        );
                                                      };

                                                      reader.readAsDataURL(
                                                        file
                                                      );
                                                    }}
                                                  />
                                                </div>
                                              </div>

                                              <div className="row mb-3">
                                                <label className="form-label col-3">
                                                  Description
                                                </label>

                                                <div className="col-9">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={
                                                      props.values.templateData
                                                        .guestDescription
                                                    }
                                                    onChange={(e) =>
                                                      props.setFieldValue(
                                                        "templateData.guestDescription",
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </div>

                                              <div className="row mb-3">
                                                <label className="form-label col-3">
                                                  Full Name
                                                </label>
                                                <div className="col-9">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    value={
                                                      props.values.templateData
                                                        .guestFullName
                                                    }
                                                    onChange={(e) =>
                                                      props.setFieldValue(
                                                        "templateData.guestFullName",
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </>
                                          )} */}

                                              {props.values.templateName ===
                                                "podcastGuestSecond" && (
                                                <>
                                                  {props.values.templateData.guestCarouselSlides.map(
                                                    (guest, index) => (
                                                      <div
                                                        key={index}
                                                        className="border rounded p-3 mb-3"
                                                      >
                                                        <h5>
                                                          Guest {index + 1}
                                                        </h5>

                                                        <input
                                                          type="file"
                                                          className="form-control mb-2"
                                                          accept="image/*"
                                                          onChange={(e) => {
                                                            const file =
                                                              e.target.files[0];
                                                            if (!file) return;

                                                            const reader =
                                                              new FileReader();

                                                            reader.onload =
                                                              () => {
                                                                const slides = [
                                                                  ...props
                                                                    .values
                                                                    .templateData
                                                                    .guestCarouselSlides,
                                                                ];

                                                                slides[
                                                                  index
                                                                ].image =
                                                                  reader.result;
                                                                slides[
                                                                  index
                                                                ].imageFile =
                                                                  file;

                                                                props.setFieldValue(
                                                                  "templateData.guestCarouselSlides",
                                                                  slides
                                                                );
                                                              };

                                                            reader.readAsDataURL(
                                                              file
                                                            );
                                                          }}
                                                        />

                                                        <input
                                                          type="text"
                                                          className="form-control mb-2"
                                                          placeholder="Guest Description"
                                                          value={
                                                            guest.guestDescription
                                                          }
                                                          onChange={(e) => {
                                                            const slides = [
                                                              ...props.values
                                                                .templateData
                                                                .guestCarouselSlides,
                                                            ];

                                                            slides[
                                                              index
                                                            ].guestDescription =
                                                              e.target.value;

                                                            props.setFieldValue(
                                                              "templateData.guestCarouselSlides",
                                                              slides
                                                            );
                                                          }}
                                                        />

                                                        <input
                                                          type="text"
                                                          className="form-control mb-2"
                                                          placeholder="Guest Full Name"
                                                          value={
                                                            guest.guestFullName
                                                          }
                                                          onChange={(e) => {
                                                            const slides = [
                                                              ...props.values
                                                                .templateData
                                                                .guestCarouselSlides,
                                                            ];

                                                            slides[
                                                              index
                                                            ].guestFullName =
                                                              e.target.value;

                                                            props.setFieldValue(
                                                              "templateData.guestCarouselSlides",
                                                              slides
                                                            );
                                                          }}
                                                        />

                                                        <button
                                                          type="button"
                                                          className="btn btn-danger mt-3"
                                                          onClick={() => {
                                                            const slides = [
                                                              ...props.values
                                                                .templateData
                                                                .guestCarouselSlides,
                                                            ];

                                                            slides.splice(
                                                              index,
                                                              1
                                                            );

                                                            props.setFieldValue(
                                                              "templateData.guestCarouselSlides",
                                                              slides
                                                            );
                                                          }}
                                                        >
                                                          Remove
                                                        </button>
                                                      </div>
                                                    )
                                                  )}

                                                  <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                      props.setFieldValue(
                                                        "templateData.guestCarouselSlides",
                                                        [
                                                          ...props.values
                                                            .templateData
                                                            .guestCarouselSlides,
                                                          {
                                                            image: "",
                                                            imageFile: null,
                                                            guestDescription:
                                                              "",
                                                            guestFullName: "",
                                                          },
                                                        ]
                                                      );
                                                    }}
                                                  >
                                                    + Add Slide
                                                  </button>
                                                </>
                                              )}
                                              {props.values.templateName ===
                                                "quote" && (
                                                <>
                                                  <div className="row mb-3">
                                                    <label className="form-label col-3">
                                                      Quote
                                                    </label>

                                                    <div className="col-9">
                                                      <textarea
                                                        className="form-control"
                                                        rows="5"
                                                        value={
                                                          props.values
                                                            .templateData
                                                            ?.quote || ""
                                                        }
                                                        onChange={(e) =>
                                                          props.setFieldValue(
                                                            "templateData.quote",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </>
                                              )}

                                              {props.values.templateName ===
                                                "carousel" && (
                                                <>
                                                  {props.values.templateData.slides.map(
                                                    (slide, index) => (
                                                      <div
                                                        key={index}
                                                        className="border rounded p-3 mb-3"
                                                      >
                                                        <h5>
                                                          Slide {index + 1}
                                                        </h5>

                                                        <input
                                                          type="file"
                                                          className="form-control mb-2"
                                                          accept="image/*"
                                                          onChange={(e) => {
                                                            const file =
                                                              e.target.files[0];
                                                            if (!file) return;

                                                            const reader =
                                                              new FileReader();

                                                            reader.onload =
                                                              () => {
                                                                const slides = [
                                                                  ...props
                                                                    .values
                                                                    .templateData
                                                                    .slides,
                                                                ];
                                                                slides[
                                                                  index
                                                                ].image =
                                                                  reader.result;
                                                                slides[
                                                                  index
                                                                ].imageFile =
                                                                  file;

                                                                props.setFieldValue(
                                                                  "templateData.slides",
                                                                  slides
                                                                );
                                                              };

                                                            reader.readAsDataURL(
                                                              file
                                                            );
                                                          }}
                                                        />

                                                        <textarea
                                                          className="form-control"
                                                          rows={4}
                                                          placeholder="Description"
                                                          value={
                                                            slide.description
                                                          }
                                                          onChange={(e) => {
                                                            const slides = [
                                                              ...props.values
                                                                .templateData
                                                                .slides,
                                                            ];
                                                            slides[
                                                              index
                                                            ].description =
                                                              e.target.value;

                                                            props.setFieldValue(
                                                              "templateData.slides",
                                                              slides
                                                            );
                                                          }}
                                                        />

                                                        <button
                                                          type="button"
                                                          className="btn btn-danger mt-3"
                                                          onClick={() => {
                                                            const slides = [
                                                              ...props.values
                                                                .templateData
                                                                .slides,
                                                            ];
                                                            slides.splice(
                                                              index,
                                                              1
                                                            );

                                                            props.setFieldValue(
                                                              "templateData.slides",
                                                              slides
                                                            );
                                                          }}
                                                        >
                                                          Remove
                                                        </button>
                                                      </div>
                                                    )
                                                  )}

                                                  <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                      props.setFieldValue(
                                                        "templateData.slides",
                                                        [
                                                          ...props.values
                                                            .templateData
                                                            .slides,
                                                          {
                                                            image: "",
                                                            imageFile: null,
                                                            description: "",
                                                          },
                                                        ]
                                                      );
                                                    }}
                                                  >
                                                    + Add Slide
                                                  </button>
                                                </>
                                              )}
                                            </div>
                                          )}
                                        </div>

                                        <div className="modal-footer">
                                          <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-bs-dismiss="modal"
                                          >
                                            Cancel
                                          </button>

                                          {/* <FormSubmitButton buttonText="Update" /> */}
                                          <FormSubmitButton
                                            buttonText={
                                              submitting
                                                ? "Updating..."
                                                : "Update"
                                            }
                                            disabled={submitting}
                                          />
                                        </div>
                                      </Form>
                                    );
                                  }}
                                </Formik>
                              </div>
                            </div>
                          </div>
                          <div
                            className="modal modal-blur fade"
                            id={`history-modal-${item.id}`}
                            tabIndex="-1"
                            role="dialog"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered modal-lg">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    Update History
                                  </h5>

                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                  ></button>
                                </div>

                                <div className="modal-body">
                                  {historyLoading ? (
                                    <div className="text-center">
                                      Loading...
                                    </div>
                                  ) : history.length === 0 ? (
                                    <div className="text-center">
                                      No History Found
                                    </div>
                                  ) : (
                                    <div className="table-responsive">
                                      <table className="table table-bordered">
                                        <thead>
                                          <tr>
                                            <th>Updated By</th>
                                            <th>Field</th>
                                            <th>Old Value</th>
                                            <th>New Value</th>
                                            <th>Date</th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {history.map((row) => (
                                            <tr key={row.id}>
                                              <td>{row.updatedBy}</td>
                                              <td>{row.updatedField}</td>
                                              <td>{row.oldValue}</td>
                                              <td>{row.newValue}</td>
                                              <td>
                                                {new Date(
                                                  row.createdAt
                                                ).toLocaleString()}
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  )}
                                </div>

                                <div className="modal-footer">
                                  <button
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                  >
                                    Close
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9">
                          <div className="text-center py-5">
                            <h5 className="text-muted">No schedules found</h5>

                            <p className="text-secondary mb-0">
                              Try changing your filters
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default ViewPostSchedule;
